const config = {
	EXTERNAL_URLS: {
		KOWALSKI: "https://discord.com/api/oauth2/authorize?client_id=546763241821437991&permissions=8&scope=applications.commands%20bot",
		KOWALSKIBETA: "https://discord.com/api/oauth2/authorize?client_id=549706228129857543&permissions=8&scope=applications.commands%20bot",
		CRYPTO: "https://web3-test.tuomaspekkanen.repl.co"
	}
}

export default config;